import { render } from "./SubjectState.vue?vue&type=template&id=119b96fb"
import script from "./SubjectState.vue?vue&type=script&lang=js"
export * from "./SubjectState.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__